var _rect, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeBin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 408.483,
    height: 408.483,
    style: {
      enableBackground: "new 0 0 408.483 408.483"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "selected",
    fillOpacity: 1,
    fill: "#fa4609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    fill: "#fa4609"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.748,388.784c0.461,11.01,9.521,19.699,20.539,19.699h191.911c11.018,0,20.078-8.689,20.539-19.699l13.705-289.316    H74.043L87.748,388.784z M247.655,171.329c0-4.61,3.738-8.349,8.35-8.349h13.355c4.609,0,8.35,3.738,8.35,8.349v165.293    c0,4.611-3.738,8.349-8.35,8.349h-13.355c-4.61,0-8.35-3.736-8.35-8.349V171.329z M189.216,171.329    c0-4.61,3.738-8.349,8.349-8.349h13.355c4.609,0,8.349,3.738,8.349,8.349v165.293c0,4.611-3.737,8.349-8.349,8.349h-13.355    c-4.61,0-8.349-3.736-8.349-8.349V171.329L189.216,171.329z M130.775,171.329c0-4.61,3.738-8.349,8.349-8.349h13.356    c4.61,0,8.349,3.738,8.349,8.349v165.293c0,4.611-3.738,8.349-8.349,8.349h-13.356c-4.61,0-8.349-3.736-8.349-8.349V171.329z",
    id: "svg_3",
    fill: "#fa4609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.567,21.043h-88.535V4.305c0-2.377-1.927-4.305-4.305-4.305h-92.971c-2.377,0-4.304,1.928-4.304,4.305v16.737H64.916    c-7.125,0-12.9,5.776-12.9,12.901V74.47h304.451V33.944C356.467,26.819,350.692,21.043,343.567,21.043z",
    id: "svg_4",
    fill: "#fa4609"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeBin);
export default __webpack_public_path__ + "static/media/orangeBin.b4c4175d8a67ce62498e0c3d6e0287e1.svg";
export { ForwardRef as ReactComponent };